/*
 * BOARDS WHOSE GO-LIVE HANDOFF PROMPT HAS BEEN WAVED OFF THIS SESSION (#435).
 *
 * In memory on purpose: "Not yet" dismisses the auto-prompt and the persistent
 * ribbon/nudge become the way back, so the prompt is never a permanent snooze
 * written to a row. But it is NOT the person's — it is the sign-in's. It is
 * cleared on sign-out (store's accounts.onChange), so a dismissal never leaks
 * from one person to the next on a shared browser: every authorised person gets
 * the prompt once per sign-in, as they should. A module leaf, not a component
 * local, precisely so the store can clear it without importing the component.
 */
const dismissed = new Set<string>();

export const handoffDismissed = {
  has: (boardId: string): boolean => dismissed.has(boardId),
  add: (boardId: string): void => { dismissed.add(boardId); },
  /** Forget every dismissal — called when the signed-in person changes. */
  clear: (): void => { dismissed.clear(); },
};
